import { VmessCategoryActions } from "@dots-crm/contracts/client";

export const VMESS_CATEGORY_ENDPOINTS_URLS = {
  create: "vmess-category",
  readMany: "vmess-category",
  readAvailable: "vmess-category/available",
  readOne: ({ categoryId }: VmessCategoryActions["readOne"]["params"]) =>
    `vmess-category/${categoryId}`,
  update: ({ categoryId }: VmessCategoryActions["update"]["params"]) =>
    `vmess-category/${categoryId}`,
  delete: ({ categoryId }: VmessCategoryActions["delete"]["params"]) =>
    `vmess-category/${categoryId}`,
};

export const VMESS_CATEGORY_TAGS = {
  vmessCategory: "vmessCategory",
};
